
import React from 'react'
import {
    List,
    Datagrid,
    Edit,
    Create,
    SimpleForm,
    DateField,
    TextField,
    EditButton,
    TextInput,
    Responsive,
    SimpleList,
    SimpleShowLayout,
    ShowButton,
    Show,
    Filter,
    TopToolbar,
    FilterButton,
    CreateButton,
    ExportButton,
    Pagination,
    required,
    SaveButton,
    DeleteButton,
    Toolbar,
    NumberInput,
    SearchInput,
    FunctionField,
} from 'react-admin'
import { useMediaQuery } from '@mui/material';
import Icon from '@mui/icons-material/Place'

export const MatchTerrainIcon = Icon

const filterArray = [
    <SearchInput source="name_like" alwaysOn />,
    <TextInput source="terrain_id" />,
    <TextInput source="name" />,
    <TextInput source="city" />,
    <TextInput source="zip_code" />,
]

const FilterList = (props) => (
    <Filter {...props}>
        {filterArray}
    </Filter>
)

const ListActions = (props) => {
    return (
        <TopToolbar>
            <FilterButton filters={filterArray} />
            <CreateButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const MatchTerrainList = (props) => (
    <List {...props} filters={<FilterList />} actions={<ListActions />} perPage={50} pagination={<Pagination rowsPerPageOptions={[10, 50, 100, 200]} />}>
        {
            useMediaQuery(theme => theme.breakpoints.down('sm')) ? (
                <SimpleList linkType="show"
                    primaryText={record => record ? `${record.name}` : ''}
                    secondaryText={record => record ? `${record.city || ''}` : ''}
                />
            ) : (
                <Datagrid>
                    <TextField source="terrain_id" sortable={true} />
                    <TextField source="name" sortable={true} />
                    <TextField source="address" sortable={false} />
                    <TextField source="zip_code" sortable={true} />
                    <TextField source="city" sortable={true} />
                    <TextField source="libelle_surface" sortable={false} label="Surface" />
                    <FunctionField label="Coordinates" render={(record) =>
                        record.latitude && record.longitude
                            ? `${record.latitude}, ${record.longitude}`
                            : '-'
                    } />
                    <DateField source="updatedAt" showTime={true} sortable={true} />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            )
        }
    </List>
)

export const MatchTerrainShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="terrain_id" />
            <TextField source="name" />
            <TextField source="address" />
            <TextField source="zip_code" />
            <TextField source="city" />
            <TextField source="latitude" />
            <TextField source="longitude" />
            <TextField source="libelle_surface" label="Surface" />
            <DateField source="createdAt" showTime={true} />
            <DateField source="updatedAt" showTime={true} />
        </SimpleShowLayout>
    </Show>
)

const MatchTerrainEditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <DeleteButton />
    </Toolbar>
);

export const MatchTerrainEdit = (props) => (
    <Edit {...props}>
        <SimpleForm toolbar={<MatchTerrainEditToolbar />}>
            <TextInput source="terrain_id" validate={required()} disabled />
            <TextInput source="name" validate={required()} fullWidth />
            <TextInput source="address" fullWidth />
            <TextInput source="zip_code" />
            <TextInput source="city" />
            <NumberInput source="latitude" step={0.000001} />
            <NumberInput source="longitude" step={0.000001} />
            <TextInput source="libelle_surface" label="Surface" />
        </SimpleForm>
    </Edit>
)

export const MatchTerrainCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" validate={required()} fullWidth />
            <TextInput source="address" fullWidth />
            <TextInput source="zip_code" />
            <TextInput source="city" />
            <NumberInput source="latitude" step={0.000001} />
            <NumberInput source="longitude" step={0.000001} />
            <TextInput source="libelle_surface" label="Surface" />
        </SimpleForm>
    </Create>
)
